import React from "react";

import { Outlet } from "react-router-dom";

export default function ErrorsLayout() {
  return (
    <div className="absolute bg-slate-900 top-0 bottom-0 left-0 right-0 flex flex-col justify-center items-center text-center text-white">
      <Outlet />
    </div>
  );
}
